import "Common/info-messages";
import { initCopyTexts } from "Functions/copy-text";
import { initCountdowns } from "Functions/countdown";
import { calculateHeaderSize } from "Functions/window";
import { setCookie, getCookie } from "Functions/cookie";
import "Ui/more-items";

let resizeTimer = false;

initCopyTexts();
initCountdowns();
calculateHeaderSize();

window.addEventListener("resize", (event) => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
        calculateHeaderSize();

        window.rEvent.dispatch("Window.resized");
    }, 250);
});

